"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterSVG = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FilterSVG = _ref => {
  let {
    stroke,
    width,
    height,
    className,
    minWidth
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    style: {
      minWidth
    },
    className: className,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.50011 1.5H15.5001C15.792 1.60236 16.02 1.83401 16.1178 2.12742C16.2157 2.42084 16.1722 2.743 16.0001 3L11.0001 8.5V15.5L7.00011 12.5V8.5L2.00011 3C1.82804 2.743 1.78457 2.42084 1.88238 2.12742C1.98018 1.83401 2.20825 1.60236 2.50011 1.5",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
exports.FilterSVG = FilterSVG;
FilterSVG.propTypes = {
  stroke: _propTypes.default.string,
  width: _propTypes.default.number,
  minWidth: _propTypes.default.number,
  height: _propTypes.default.number,
  className: _propTypes.default.string
};
FilterSVG.defaultProps = {
  stroke: '#C0C0CF',
  width: 18,
  height: 17,
  minWidth: 18,
  className: ''
};